// Cart engine — no backend exists, so the cart lives entirely in
// localStorage. Every mutation dispatches "cart:updated" so the dock
// badge and drawer can re-render without being tightly coupled to this
// module's internals.
const CART_KEY = "jabuilds_cart_v1";

function readCart() {
    try {
        const raw = localStorage.getItem(CART_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        if (parsed && Array.isArray(parsed.items)) return parsed;
    } catch {
        // fall through to empty cart on any parse/shape error
    }
    return { schemaVersion: 1, items: [] };
}

function writeCart(cart) {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    window.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
}

export function getCart() {
    return readCart();
}

export function getCount() {
    return readCart().items.reduce((sum, item) => sum + item.qty, 0);
}

export function getSubtotal() {
    return readCart().items.reduce(
        (sum, item) => sum + item.priceValue * item.qty,
        0,
    );
}

export function addItem(product, qty = 1) {
    const cart = readCart();
    const existing = cart.items.find((item) => item.id === product.id);
    if (existing) {
        existing.qty += qty;
    } else {
        cart.items.push({
            id: product.id,
            type: product.type,
            name: product.name,
            priceLabel: product.priceLabel,
            priceValue: product.priceValue,
            specsSummary: product.specs
                ? Object.values(product.specs).join(", ")
                : "",
            image: product.image,
            qty,
        });
    }
    writeCart(cart);
}

export function setQty(id, qty) {
    const cart = readCart();
    const item = cart.items.find((i) => i.id === id);
    if (!item) return;
    if (qty <= 0) {
        cart.items = cart.items.filter((i) => i.id !== id);
    } else {
        item.qty = qty;
    }
    writeCart(cart);
}

export function removeItem(id) {
    const cart = readCart();
    cart.items = cart.items.filter((i) => i.id !== id);
    writeCart(cart);
}

// Puts a previously removed cart line back exactly as it was (Undo).
export function restoreItem(item) {
    const cart = readCart();
    if (!cart.items.some((i) => i.id === item.id)) cart.items.push(item);
    writeCart(cart);
}

export function clearCart() {
    writeCart({ schemaVersion: 1, items: [] });
}

// Keep the badge/drawer in sync if the cart changes in another tab.
window.addEventListener("storage", (event) => {
    if (event.key === CART_KEY) {
        window.dispatchEvent(
            new CustomEvent("cart:updated", { detail: readCart() }),
        );
    }
});
